<template>
<div class="tab-container">
  <van-tabs type="card">
    <van-tab :title="'我的订单(' + my_cnt + ')'">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      >
        <van-card
          v-for="item in list"
          :key="item.trade_id"
          :tag="item.tag"
          :price="item.price"
          :origin-price="item.origin_price"
          :thumb="item.thumb"
        >
          <van-tag type="danger" slot="footer">约返{{item.commission}}</van-tag>
          <van-tag plain slot="tags">{{item.trade_id}}</van-tag>
          <div slot="title">
            <div>{{item.mtime}}<div>
            <div>{{item.title}}</div>
            <div>&nbsp;</div>
          </div>
        </van-card>
      </van-list>
    </van-tab>

    <van-tab :title="'好友订单(' + friend_cnt + ')'">
      <van-list
        v-model="friend_loading"
        :finished="friend_finished"
        @load="friend_onLoad"
      >
        <van-card
          v-for="item in friend_list"
          :key="item.trade_id"
          :tag="item.tag"
          :price="item.price"
          :origin-price="item.origin_price"
          :thumb="item.thumb"
        >
          <van-tag type="danger" slot="footer">约返{{item.commission}}</van-tag>
          <van-tag plain slot="tags">{{item.trade_id}}</van-tag>
          <div slot="title">
            <div>{{item.mtime}}<div>
            <h3>{{item.trader}}<h3>
          </div>
        </van-card>
      </van-list>
    </van-tab>
  </van-tabs>
</div>
</template>

<script>
import { Tab, Tag, Tabs, Cell, List, Card } from "vant";

export default {
  components: {
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [Tabs.name]: Tabs,
    [Cell.name]: Cell,
    [List.name]: List,
    [Card.name]: Card
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      my_cnt: "-",
      pn: 0,
      ps: 8,
      friend_list: [],
      friend_loading: false,
      friend_finished: false,
      friend_cnt: "-",
      friend_pn: 0
    };
  },
  methods: {
    loadOrders(openid) {
      this.$http
        .get("https://cb.xhare.cn/orders", {
          params: { openid: openid, pn: this.pn, ps: this.ps, type: 0 }
        })
        .then(
          function(res) {
            if (res.data.code == 0) {
              if (this.pn == 0) {
                this.my_cnt = "" + res.data.count[0];
                this.friend_cnt = "" + res.data.count[1];
              }
              if (res.data.data.length < this.ps) {
                this.finished = true;
              }
              if (res.data.data.length > 0) {
                res.data.data.forEach(element => {
                  this.list.push({
                    trade_id: element.trade_id,
                    title: element.title,
                    thumb: element.thumb,
                    num: element.num,
                    price: element.price,
                    origin_price: element.origin_price,
                    commission: element.commission,
                    tag: element.tag,
                    mtime: element.mtime
                  });
                });
              }

              this.loading = false;
            }
            this.pn++;
          }.bind(this)
        )
        .catch(
          function() {
            this.redirect();
          }.bind(this)
        );
    },
    friend_loadOrders(openid) {
      this.$http
        .get("https://cb.xhare.cn/orders", {
          params: { openid: openid, pn: this.friend_pn, ps: this.ps, type: 1 }
        })
        .then(
          function(res) {
            if (res.data.code == 0) {
              if (this.friend_pn == 0) {
                this.my_cnt = "" + res.data.count[0];
                this.friend_cnt = "" + res.data.count[1];
              }
              if (res.data.data.length > 0) {
                res.data.data.forEach(element => {
                  this.friend_list.push({
                    trade_id: element.trade_id,
                    trader: element.trader,
                    title: element.title,
                    thumb: element.thumb,
                    num: element.num,
                    price: element.price,
                    origin_price: element.origin_price,
                    commission: element.commission,
                    tag: element.tag,
                    mtime: element.mtime
                  });
                });
              }

              this.friend_loading = false;
              if (res.data.data.length < this.ps) {
                this.friend_finished = true;
              }
            }
            this.friend_pn++;
          }.bind(this)
        )
        .catch(
          function() {
            this.redirect();
          }.bind(this)
        );
    },
    redirect() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1939c838a577589a&redirect_uri=https://m.xhare.cn/i/%23orders&response_type=code&scope=snsapi_base&state=ucenter";
    },
    onLoad() {
      let openid = sessionStorage.getItem("openid");
      if (openid) {
        this.loadOrders(openid);
      } else {
        this.$http
          .get("https://cb.xhare.cn/openid", {
            params: {
              code: (window.location.search
                .substr(1)
                .match(/(^|&)code=([^&]*)(&|$)/i) || [])[2]
            }
          })
          .then(
            function(res) {
              if (res.data.openid == "") {
                this.redirect();
              } else {
                this.loadOrders(res.data.openid);
                sessionStorage.setItem("openid", res.data.openid);
              }
            }.bind(this)
          )
          .catch(
            function() {
              this.redirect();
            }.bind(this)
          );
      }
    },
    friend_onLoad() {
      let openid = sessionStorage.getItem("openid");
      if (openid) {
        this.friend_loadOrders(openid);
      } else {
        this.$http
          .get("https://cb.xhare.cn/openid", {
            params: {
              code: (window.location.search
                .substr(1)
                .match(/(^|&)code=([^&]*)(&|$)/i) || [])[2]
            }
          })
          .then(
            function(res) {
              if (res.data.openid == "") {
                this.redirect();
              } else {
                this.friend_loadOrders(res.data.openid);
                sessionStorage.setItem("openid", res.data.openid);
              }
            }.bind(this)
          )
          .catch(
            function() {
              this.redirect();
            }.bind(this)
          );
      }
    }
  }
};
</script>

<style lang="less">
.van-card__left {
  text-align: left;
}
</style>
